import Index from "../componentes/Index.vue";

const routes = [
    ...route(`/lista-colaboradores`, Index, {
        Auth: true,
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;